import React, { useEffect, useState } from 'react'
import Proptypes from 'prop-types'
import { Button, Form, Grid, Modal } from 'semantic-ui-react'
import Swal from 'sweetalert2'
import { UpdateTemplate } from '../../services/configuration-template'
import styles from './alert-mgmt.module.css'

const EditModal = ({ templateData, open, setOpen, setTemplate }) => {
  const [formData, setFormData] = useState({})

  useEffect(() => {
    setFormData(templateData)
  }, [])

  const handleChange = (e) => {
    e.persist()
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    Swal.showLoading()
    const queryParams = { product: 'cold' }
    const res = await UpdateTemplate(formData, queryParams)
    if (res.success) {
      await Swal.fire('Template Updated Successfully', '', 'success')
      setOpen(false)
      setTemplate((prevState) => ({
        ...prevState,
        configurationTemplate: res.data,
      }))
    } else {
      Swal.fire('Error Updating Template', '', 'error')
    }
  }
  return (
    <>
      <Modal open={open}>
        <Modal.Header style={{ backgroundColor: '#4b6587', color: '#FFF' }}>
          {templateData['template name']}
        </Modal.Header>
        <Modal.Content>
          <Form
            id="editForm"
            style={{
              backgroundColor: 'rgb(216, 231, 234)',
              padding: 10,
              borderRadius: 9,
            }}
            onSubmit={handleSubmit}
          >
            <Grid columns={3}>
              {/* <Grid.Row>{renderForm()}</Grid.Row> */}
              <Grid.Row>
                {templateData['warning high temperature(celsius)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>warning high temperature</span>
                    <br />
                    <input
                      name="warning high temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['warning high temperature'] ||
                        templateData['warning high temperature(celsius)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['warning low temperature(celsius)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>warning low temperature</span>
                    <br />
                    <input
                      name="warning low temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['warning low temperature'] ||
                        templateData['warning low temperature(celsius)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['critical high temperature(celsius)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>
                      critical high temperature
                    </span>
                    <br />
                    <input
                      name="critical high temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['critical high temperature'] ||
                        templateData['critical high temperature(celsius)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['critical low temperature(celsius)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>critical low temperature</span>
                    <br />
                    <input
                      name="critical low temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['critical low temperature'] ||
                        templateData['critical low temperature(celsius)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['compressor temperature(celsius)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>compressor temperature</span>
                    <br />
                    <input
                      name="compressor temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['compressor temperature'] ||
                        templateData['compressor temperature(celsius)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['hw fridge interior temperature(celsius)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>
                      hw fridge interior temperature
                    </span>
                    <br />
                    <input
                      name="hw fridge interior temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['hw fridge interior temperature'] ||
                        templateData['hw fridge interior temperature(celsius)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['hw room temperature(celsius)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>hw room temperature</span>
                    <br />
                    <input
                      name="hw room temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['hw room temperature'] ||
                        templateData['hw room temperature(celsius)']
                      }
                      required
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />

            <Grid columns={3}>
              <Grid.Row>
                {templateData['warning humidity(percent)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>warning humidity</span>
                    <br />
                    <input
                      name="warning humidity"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['warning humidity'] ||
                        templateData['warning humidity(percent)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['critical humidity(percent)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>critical humidity</span>
                    <br />
                    <input
                      name="critical humidity"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['critical humidity'] ||
                        templateData['critical humidity(percent)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['hw fridge interior humidity(percent)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>
                      hw fridge interior humidity
                    </span>
                    <br />
                    <input
                      name="hw fridge interior humidity"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['hw fridge interior humidity'] ||
                        templateData['hw fridge interior humidity(percent)']
                      }
                      required
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />

            <Grid columns={2}>
              <Grid.Row>
                {templateData['compressor temperature'] && (
                  <Grid.Column>
                    <span className={styles.cap}>compressor temperature</span>
                    <br />
                    <input
                      name="compressor temperature"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['compressor temperature'] ||
                        templateData['compressor temperature']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['compressor vibration'] && (
                  <Grid.Column>
                    <span className={styles.cap}>compressor vibration</span>
                    <br />
                    <input
                      name="compressor vibration"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['compressor vibration'] ||
                        templateData['compressor vibration']
                      }
                      required
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />

            <Grid columns={3}>
              <Grid.Row>
                {templateData['door open neglect(minutes)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>door open neglect</span>
                    <br />
                    <input
                      name="door open neglect"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['door open neglect'] ||
                        templateData['door open neglect(minutes)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['door open count'] && (
                  <Grid.Column>
                    <span className={styles.cap}>door open count</span>
                    <br />
                    <input
                      name="door open count"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['door open count'] ||
                        templateData['door open count']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['door left open(minutes)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>door left open</span>
                    <br />
                    <input
                      name="door left open"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['door left open'] ||
                        templateData['door left open(minutes)']
                      }
                      required
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />

            <Grid columns={2}>
              <Grid.Row>
                {templateData['out of location'] && (
                  <Grid.Column>
                    <span className={styles.cap}>out of location</span>
                    <br />
                    <input
                      name="out of location"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['out of location'] ||
                        templateData['out of location']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['Unauthorized movement'] !== undefined && (
                  <Grid.Column>
                    <span className={styles.cap}>Unauthorized movement</span>
                    <br />
                    <select
                      name="Unauthorized movement"
                      value={
                        formData['Unauthorized movement'] ||
                        templateData['Unauthorized movement']
                      }
                      onChange={handleChange}
                    >
                      {/* eslint-disable-next-line react/jsx-boolean-value */}
                      <option value={true}>True</option>
                      <option value={false}>False</option>
                    </select>
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />

            <Grid columns={3}>
              <Grid.Row>
                {templateData['low light(lux)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>low light</span>
                    <br />
                    <input
                      name="low light"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['low light'] || templateData['low light(lux)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['hw fridge interior light level'] && (
                  <Grid.Column>
                    <span className={styles.cap}>
                      hw fridge interior light level
                    </span>
                    <br />
                    <input
                      name="hw fridge interior light level"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['hw fridge interior light level'] ||
                        templateData['hw fridge interior light level']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['abnormal power'] && (
                  <Grid.Column>
                    <span className={styles.cap}>abnormal power</span>
                    <br />
                    <input
                      name="abnormal power"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['abnormal power'] ||
                        templateData['abnormal power']
                      }
                      required
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />

            <Grid columns={2}>
              <Grid.Row>
                {templateData['device inactive threshold(minute)'] && (
                  <Grid.Column>
                    <span className={styles.cap}>
                      device inactive threshold
                    </span>
                    <br />
                    <input
                      name="device inactive threshold"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['device inactive threshold'] ||
                        templateData['device inactive threshold(minute)']
                      }
                      required
                    />
                  </Grid.Column>
                )}

                {templateData['idle asset threshold'] && (
                  <Grid.Column>
                    <span className={styles.cap}>idle asset threshold</span>
                    <br />
                    <input
                      name="idle asset threshold"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={
                        formData['idle asset threshold'] ||
                        templateData['idle asset threshold']
                      }
                      required
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />
            <Grid columns={1}>
              <Grid.Row>
                {templateData.voltage !== undefined && (
                  <Grid.Column>
                    <span className={styles.cap}>Voltage</span>
                    <br />
                    <input
                      name="voltage"
                      className={styles.input}
                      type="number"
                      onChange={handleChange}
                      value={formData.voltage || templateData.voltage}
                      required
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>

            <hr />
            <Button
              from="editForm"
              type="submit"
              style={{ backgroundColor: '#5cb85c', color: '#FFF' }}
            >
              Save
            </Button>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    </>
  )
}

EditModal.propTypes = {
  templateData: Proptypes.object,
  open: Proptypes.bool,
  setOpen: Proptypes.func,
  setTemplate: Proptypes.func,
}

export default EditModal
